/*
 * Variant option slider (Swiper 11).
 * Turns every [data-variant-swiper] container into a horizontal slider with
 * prev/next navigation and mouse-wheel scrolling. Loaded once from theme.liquid
 * so it is never re-injected as inline markup on variant/combined-product reloads.
 */
(function () {
  var SWIPER_CSS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
  var SWIPER_JS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
  var loading;

  function loadSwiper() {
    if (window.Swiper) return Promise.resolve();
    if (loading) return loading;
    loading = new Promise(function (resolve, reject) {
      if (!document.querySelector('link[data-cb-swiper-css]')) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = SWIPER_CSS;
        link.setAttribute('data-cb-swiper-css', '');
        document.head.appendChild(link);
      }
      var s = document.createElement('script');
      s.src = SWIPER_JS;
      s.async = true;
      s.onload = resolve;
      s.onerror = reject; 
      document.head.appendChild(s);
    });
    return loading;
  }

  /* Center the arrows vertically on the (square) swatch image, whatever its
     size ends up being for the current slidesPerView. */
  function centerNav(el) {
    var wrap = el.closest('[data-variant-swiper-wrap]') || el.parentElement;
    var img = el.querySelector('.cb-option-image');
    if (wrap && img && img.offsetHeight) {
      wrap.style.setProperty('--cb-nav-top', (img.offsetHeight / 2) + 'px');
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-variant-swiper]').forEach(function (el) {
      if (el.dataset.swiperReady) return;
      el.dataset.swiperReady = '1';
      var wrap = el.closest('[data-variant-swiper-wrap]') || el.parentElement;
      new window.Swiper(el, {
        direction: 'horizontal',
        slidesPerView: 3.8,
        spaceBetween: 16,
        mousewheel: true,
        breakpoints: {
          1024: { slidesPerView: 5.6 }
        },
        navigation: {
          prevEl: wrap.querySelector('[data-variant-swiper-prev]'),
          nextEl: wrap.querySelector('[data-variant-swiper-next]')
        }
      });

      centerNav(el);
      el.querySelectorAll('img').forEach(function (img) {
        if (img.complete) return;
        img.addEventListener('load', function () { centerNav(el); }, { once: true });
      });
    });
  }

  var resizeScheduled = false;
  window.addEventListener('resize', function () {
    if (resizeScheduled) return;
    resizeScheduled = true;
    window.requestAnimationFrame(function () {
      resizeScheduled = false;
      document.querySelectorAll('[data-variant-swiper]').forEach(centerNav);
    });
  });

  function init(root) {
    loadSwiper().then(function () { initAll(root); }).catch(function () {});
  }

  window.CBVariantSwiper = { init: init };

  /* Re-init pickers injected after variant / combined-product reloads. */
  var scheduled = false;
  function scheduleInit() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      init();
    });
  }

  function boot() {
    init();
    if (!window.__cbVariantSwiperObserver) {
      window.__cbVariantSwiperObserver = new MutationObserver(scheduleInit);
      window.__cbVariantSwiperObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
